import styled from 'styled-components/macro'

export const Wrapper = styled.div`
  background: ${props => props.theme.white};
  width: 100%;
  border-radius: 8px;
  padding: 16px;

  .content {
    transition: all 0.2s ease-in-out;
  }

  .stat {
    margin-top: 16px;
    color: ${props => props.theme.normalText};

    .label {
      font-size: 14px;
    }

    .value {
      font-weight: 600;
      font-size: 18px;
    }
  }

  .graph {
    height: 80px;
    width: 100%;
    margin-top: 32px;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 8px;

    .bar {
      flex: 1;
      background: linear-gradient(50deg, hsl(206 100% 53% / 1), hsl(192deg 98% 52%));
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      color: ${props => props.theme.white};
      display: flex;
      align-items: flex-end;
      justify-content: center;
      font-weight: 600;
      font-size: 14px;
      min-height: 22%;
      position: relative;

      :hover {
        .value {
          display: block;
        }
      }

      .value {
        position: absolute;
        top: -16px;
        left: 0;
        right: 0;
        font-size: 12px;
        color: ${props => props.theme.mutedText};
        text-align: center;
      }
    }
  }
`
